import {Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, AfterViewInit} from '@angular/core';
import 'rxjs/add/operator/filter';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import { MenuItems } from '../../shared/menu-items/menu-items';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from'@angular/router';
import { SessionService } from 'app/sessions/session.service';
import { UtilService } from 'app/hrms/shared/util.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { UserService } from 'app/users/shared/user.service';
export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
        state('no-block, void',
            style({
                overflow: 'hidden',
                height: '0px',
            })
        ),
        state('yes-block',
            style({
                height: AUTO_STYLE,
            })
        ),
        transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
        ])
    ])
  ]
})

export class AdminLayoutComponent implements OnInit {
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  isCollapsedSideBar = 'no-block';
  toggleOn = true;
  windowWidth: number;
  
  authenticated: boolean = false;
  state: string = '';
  error:any;
  email: string;
  password: string;
  name : string;
  image : string;
  isAutomatic: any;
  branch: string;
  role:string;

  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;
  show_notifi: any;

  shipmentsNotificationsList:any = [];
  leavesNotificationsList:any = [];
  myLeavesNotificationsList:any = [];
  myAttendanceNotificationsList:any = [];
  attendanceNotificationsList:any = [];
  viewType:string ="few";
  noNotif:boolean = false;
  noNotifSelf:boolean = false;
  constructor(public menuItems: MenuItems,public af: AngularFireAuth,private router: Router, private ss:SessionService, private util:UtilService, private ls:LogisticsService, private hrms:HRMSService, private us:UserService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);

    this.af.authState.subscribe(
      (auth) =>{
        if(auth != null){
          this.authenticated = true;
        }
      }
    );
    //this.router.navigateByUrl('/dashboard');
    this.navigate();
  }

  ngOnInit() {
    firebase.database().ref('users/'+ localStorage.getItem('courierapp_user_id')).once("value").then((snapshot)=>{
      if(snapshot.val())
      {
      firebase.database().ref('branches/'+ snapshot.child('branch').val()).once("value").then((branchSnapshot)=>{
        this.branch = branchSnapshot.child('name').val();
        //console.log("email",this.email);
      });
      this.name = snapshot.child('firstName').val()+" "+snapshot.child('lastName').val();
      localStorage.setItem('courierapp_userName', snapshot.child('name').val());
      localStorage.setItem('courierapp_role', snapshot.child('role').val());
      this.role = snapshot.child('role').val();
      
      if(snapshot.child('imageUrl').val())
      {
        this.image = snapshot.child('imageUrl').val();
      }
      else
      {
        this.image = "assets/images/avatar-4.png";
        //this.name = localStorage.getItem('courierapp_userName');
      }
    }
    else{
      this.ss.clear();
      this.router.navigateByUrl('/dashboard');
    }
    });

    firebase.database().ref("autoAssign").on("value",(data)=>{
      //console.log(data.val());
      this.isAutomatic = data.val();
    });
    //this.checkLoginRole();
  }
  checkLoginRole()
  {
    if(this.ss.getUserRole == 'admin' || this.ss.getUserRole == 'super admin')
    {
      this.getShipmentNotification();
      this.getLeaveNotification();
      this.getAttendanceNotification();
      this.getMyLeaveNotification();
      this.getMyAttendanceNotification();  
    }
    else
    {
      this.getMyLeaveNotification();
      this.getMyAttendanceNotification();
    }
    this.checkNotifAvailable();
  }
  checkNotifAvailable()
  {
    setTimeout(() => {
      this.noNotif = this.shipmentsNotificationsList.length == 0 && this.leavesNotificationsList.length == 0 
      && this.myLeavesNotificationsList.length == 0 && this.myAttendanceNotificationsList.length == 0 && this.attendanceNotificationsList.length == 0;
      this.noNotifSelf = this.myLeavesNotificationsList.length == 0 && this.myAttendanceNotificationsList.length == 0;
      //console.log("noNotif noNotifSelf ",this.noNotif, this.noNotifSelf);
    }, 3000);
  }
  onClickedOutside(e: Event) {
      if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
          this.toggleOn = true;
          this.verticalNavType = 'offcanvas';
      }
  }
  autoAssign()
  {
    firebase.database().ref("autoAssign").set(true);
  }
  manualAssign()
  {
    firebase.database().ref("autoAssign").set(false);
  }
  onChange(event)
  {
    if(event)
    {
      firebase.database().ref("autoAssign").set(true);
    }
    else
    {
      firebase.database().ref("autoAssign").set(false);
    }
    
  }
  logout()
  {
    this.af.auth.signOut();
    this.router.navigate(['/authentication/login']);
    this.authenticated = false;
    firebase.database().ref("fcmTokens").child(localStorage.getItem("courierapp_user_id")).remove();
    localStorage.clear();
  }
  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = 'tablet';
        this.verticalNavType = 'collapsed';
        this.verticalEffect = 'push';
      } else if (windowWidth < 768) {
        this.deviceType = 'mobile';
        this.verticalNavType = 'offcanvas';
        this.verticalEffect = 'overlay';
      } else {
        this.deviceType = 'desktop';
        this.verticalNavType = 'expanded';
        this.verticalEffect = 'shrink';
      }
  }

  searchFriendList(event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function(elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === 'out' ? 'in' : 'out';
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === 'off' ? 'on' : 'off';
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
        this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
    }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }
  navigate()
  {
    // if(this.ss.getUserRole == "super admin")
    // {
    //   this.router.navigateByUrl('/dashboard');
    // }
    // else if(this.ss.getUserRole == "admin")
    // {
    //   this.router.navigateByUrl('/dashboard');
    // }
    // else
    // {
    //   this.router.navigateByUrl('/hrms');
    // }
    if(this.ss.getUserRole !== "super admin" && this.ss.getUserRole !== "admin") {
      this.router.navigateByUrl('/hrms');
    }
  }

  notificationToggle() {
    this.show_notifi = !this.show_notifi;
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('bgoverlay');

    const slide_notifi = document.getElementsByClassName('notifications')[0];
    if(slide_notifi)
    slide_notifi.classList.toggle('slide_notifi');
    if(this.show_notifi)
    {
      this.checkLoginRole();
    }
    this.checkNotifAvailable();
  }
  receiveMessage() {
    this.notificationToggle();
  }
  getShipmentNotification()
  {
    this.ls.getNewlyArrivedShipments().on("value",(data)=>{
      var shipments =  data.val();
      this.shipmentsNotificationsList = [];
      for(let i in shipments)
      {
        if(shipments[i].branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
        {
          var createdAt  = (shipments[i].createdAt).split("/");
          var diff = this.util.diff_hours(new Date(),new Date(shipments[i].createdAtTimeStamp));
          var d = {
            message: "New shipment has been arrived with shipment #: "+shipments[i].id,
            id: shipments[i].id,
            //time: diff < 24 ? diff+" hours ago": shipments[i].createdAt
            time: this.util.diff(new Date(),new Date(shipments[i].createdAtTimeStamp))
          }
          this.shipmentsNotificationsList.push(d);
        }
      }
    });
  }
  
  getLeaveNotification()
  {
    this.hrms.getNewLeaveNotif().on("value",(data)=>{
      var leaves =  data.val();
      this.leavesNotificationsList = [];
      for(let i in leaves)
      {
        this.us.getUser(leaves[i].uid).once("value").then((userData)=>{
          var user = userData.val();
          if(user.branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
          {
            if(leaves[i].status == 'Pending')
            {
              var diff = this.util.diff_hours(new Date(),new Date(leaves[i].updatedAt));
              var d = {
                message: "Leave of "+user.name+"("+leaves[i].requestedOn+")"+" is waiting for your approval.",
                id: i,
                //time: diff < 24 ? diff+" hours ago": leaves[i].requestedOn
                time: this.util.diff(new Date(),new Date(leaves[i].updatedAt))
              }
              this.leavesNotificationsList.push(d);
            }
          }
        });
      }
  });
}
getMyLeaveNotification()
  {
    this.hrms.getMyLeaveNotification(this.ss.getUserId).on("value",(data)=>{
      var leaves =  data.val();
      this.myLeavesNotificationsList = [];
      for(let i in leaves)
      {
          if(leaves[i].notif == 'unread' && leaves[i].status == 'Approved')
          {
            var diff = this.util.diff_hours(new Date(),new Date(leaves[i].updatedAt));
              var d = {
                message: "Your leave has been approved",
                id:i,
                //time: diff < 24 ? diff+" hours ago": leaves[i].requestedOn
                time: this.util.diff(new Date(),new Date(leaves[i].updatedAt))
              }
              this.myLeavesNotificationsList.push(d);
          }
          else if(leaves[i].notif == 'unread' && leaves[i].status == 'Rejected')
          {
            var diff = this.util.diff_hours(new Date(),new Date(leaves[i].updatedAt));
              var d = {
                message: "Your leave has been rejected",
                id:i,
                //time: diff < 24 ? diff+" hours ago": leaves[i].requestedOn
                time: this.util.diff(new Date(),new Date(leaves[i].updatedAt))
              }
              this.myLeavesNotificationsList.push(d);
          }
      }
  });
  }
  view(data,from)
  {
    switch(from)
    {
      case "shipment":
      this.hrms.changeNotifStatusToRead(data.id,"shipments").then(()=>{
        this.router.navigate(['/view-shipment-details'], { queryParams : {key: data.id, from: 'shipment'}  });
        this.notificationToggle();
      });
      break;
      case "leave":
      this.hrms.changeNotifStatusToRead(data.id,"employeeLeaves").then(()=>{
        this.router.navigate(['/leaves']);
        this.notificationToggle();
      });
      break;
      case "attendance":
      this.hrms.updateAttendanceNotif(data.id,"read").then(()=>{
        this.router.navigate(['/attendance']);
        this.notificationToggle();
      });
      break;
    }
  }
  close(data,from)
  {
    switch(from)
    {
      case "shipment":
      this.hrms.changeNotifStatusToRead(data.id,"shipments").then(()=>{
        this.notificationToggle();
      });
      break;
      case "leave":
      this.hrms.changeNotifStatusToRead(data.id,"employeeLeaves").then(()=>{
        this.notificationToggle();
      });
      break;
      case "attendance":
      this.hrms.updateAttendanceNotif(data.id,"read").then(()=>{
        this.notificationToggle();
      });
      break;
    }
}
getMyAttendanceNotification()
{
  this.hrms.getMyAttendanceNotification(this.ss.getEmployeeId).on("value",(data)=>{
  this.myAttendanceNotificationsList = [];    
    var attendanceNotif = data.val();
    for(let i in attendanceNotif)
    {
      //console.log("my attendanceNotif",attendanceNotif[i],i);
      if(attendanceNotif[i].notif == "unread" && attendanceNotif[i].status == "approved")
      {
        var diff = this.util.diff_hours(new Date(),new Date(attendanceNotif[i].updatedAt));
        var d = {
          message: "Your attendance has been approved",
          id: i,
          //time: diff < 24 ? diff+" hours ago": attendanceNotif[i].date
          time: this.util.diff(new Date(),new Date(attendanceNotif[i].updatedAt))
        }
        this.myAttendanceNotificationsList.push(d);
    }
    else if(attendanceNotif[i].notif == "unread" && attendanceNotif[i].status == "rejected")
      {
        var diff = this.util.diff_hours(new Date(),new Date(attendanceNotif[i].updatedAt));
        var d = {
          message: "Your attendance has been rejected",
          id: i,
          //time: diff < 24 ? diff+" hours ago": attendanceNotif[i].date
          time: this.util.diff(new Date(),new Date(attendanceNotif[i].updatedAt))
        }
        this.myAttendanceNotificationsList.push(d);
    }
  }
});
}

getAttendanceNotification()
{
  this.hrms.getAttendanceNotification().on("value",(data)=>{
  this.attendanceNotificationsList = [];    
    var attendanceNotif = data.val();
    console.log("attendanceNotificationsList");
    for(let i in attendanceNotif)
    {
      //console.log("attendanceNotif",attendanceNotif[i],i);
      if(attendanceNotif[i].status == "pending")
      {
        this.us.getEmployeeDetails(Number(attendanceNotif[i].eid)).once("value").then((userData)=>{
          userData.forEach(element => {
            var user = element.val();
            //console.log("user",user);
            if(user.branch == this.ss.getUserBranch || this.ss.getUserRole == 'super admin')
            {
                var diff = this.util.diff_hours(new Date(),new Date(attendanceNotif[i].updatedAt));
                var d = {
                  message: "Attedance of "+user.name+" ("+attendanceNotif[i].date+")"+" is waiting for your approval.",
                  id: i,
                  //time: diff < 24 ? diff+" hours ago": attendanceNotif[i].date,
                  time: this.util.diff(new Date(),new Date(attendanceNotif[i].updatedAt)),
                  dateId: attendanceNotif[i].date
                }
                this.attendanceNotificationsList.push(d);
                //console.log("this.attendanceNotificationsList",this.attendanceNotificationsList);
              }
          });
      });
    }
  }
});
}
onClickView(type)
{
  this.viewType = type;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/layouts/admin/admin-layout.component.ts